import { useSelector } from 'react-redux'
import classnames from 'classnames'
import { useTranslation } from 'react-i18next'
import MaterialCard from '../../../../materials/MaterialCard'
import PackageCard from '../PackageCard'

import styles from './ProgramPricing.module.scss'

const ProgramPricing = () => {
  const { t } = useTranslation()
  const course = useSelector(state => state.programPresentation.course)

  return (
    <div className={classnames('p-3', styles['program-pricing'])}>
      {course.packages.length > 0 && <p className={styles.eyebrow}>{t('programs.landing.coachingFee.eyebrow')}</p>}
      {course.packages.map(p => (
        <PackageCard key={p.id} pkg={p} currency={course.community.currency} className='mb-3'/>
      ))}
      {course.materials.length > 0 && <p className={styles.eyebrow}>{t('programs.landing.coachingFee.materialsEyebrow')}</p>}
      {course.materials.map(m => (
        <MaterialCard key={m.id} className='mb-3' material={m} withPrice />
      ))}
    </div>
  )
}

export default ProgramPricing
